// Layout container scaffold (consistent page width/padding).
export default function Container({ children, className = "" }) {
  return (
    <div className={`container ${className}`}>
      {children}
    </div>
  );
}